
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 17v-2h2v2h13v2H8v2H6v-2H3v-2h3zm10-6V9h2v2h3v2h-3v2h-2v-2H3v-2h13zM6 5V3h2v2h13v2H8v2H6V7H3V5h3z","fill":"#FFF"}})])
          )
        }
      }
    